/* Lune motion — tags key storefront elements for scroll-reveal and animates
   stat count-ups. Zero dependencies, IntersectionObserver-based, inert under
   prefers-reduced-motion and in browsers without IO support. */
(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var GROUPS = [
    '.lune-lineup__card',
    '.lune-proof__stat',
    '.lune-value__chip',
    '.lune-reviews__card',
    '.lune-trust__item',
    '.lune-vs tbody tr',
    '.lune-quiz__opt',
  ];
  var SINGLES = [
    '.lune-lineup__head', '.lune-proof__heading', '.lune-proof__body',
    '.lune-offer__copy', '.lune-offer__media', '.lune-founder__media',
    '.lune-founder__inner > div:last-child', '.lune-pdpp__row',
    '.lune-cta__inner', '.lune-email__inner', '.lune-faq__item',
    '.lune-cmp__head', '.lune-vs__head', '.lune-value__heading',
    '.lune-value__body', '.lune-spot__media', '.lune-spot__copy',
  ];

  function tag(el, delay) {
    if (el.hasAttribute('data-lune-reveal')) return;
    el.setAttribute('data-lune-reveal', '');
    if (delay) el.style.setProperty('--lr-delay', delay + 'ms');
  }

  GROUPS.forEach(function (sel) {
    var parents = new Map();
    document.querySelectorAll(sel).forEach(function (el) {
      var p = el.parentElement;
      var n = parents.get(p) || 0;
      tag(el, Math.min(n * 70, 420));
      parents.set(p, n + 1);
    });
  });
  SINGLES.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) { tag(el, 0); });
  });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('lr-in');
      io.unobserve(entry.target);
      entry.target.querySelectorAll('[data-lune-countup]').forEach(countUp);
      if (entry.target.hasAttribute('data-lune-countup')) countUp(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  document.querySelectorAll('[data-lune-reveal]').forEach(function (el) { io.observe(el); });

  // Count-up: animates the leading number of the element's text (decimals kept).
  var counted = new WeakSet();
  function countUp(el) {
    if (counted.has(el)) return;
    counted.add(el);
    var text = el.textContent;
    var m = text.match(/^(\s*)(\d+(?:\.\d+)?)([\s\S]*)$/);
    if (!m) return;
    var target = parseFloat(m[2]);
    var decimals = (m[2].split('.')[1] || '').length;
    var suffix = m[3];
    var t0 = null;
    var DUR = 950;
    function frame(t) {
      if (t0 === null) t0 = t;
      var p = Math.min((t - t0) / DUR, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = m[1] + (target * eased).toFixed(decimals) + suffix;
      if (p < 1) requestAnimationFrame(frame);
      else el.textContent = text;
    }
    requestAnimationFrame(frame);
  }

  // Stat figures get count-ups automatically
  document.querySelectorAll('.lune-proof__num, .lune-spot__statnum').forEach(function (el) {
    if (/^\s*\d/.test(el.textContent)) el.setAttribute('data-lune-countup', '');
  });
})();
